import { ModuleItem } from '../../../models/module-item';
import { ModuleItemsConfig } from '../../../models/module-items-config';
import { MODULE_ITEM_CHOICES_IDENTIFIER } from '../../../core/dashboard-constants';

export function getModuleItemSortOrderArray(moduleItems: ModuleItem[]): number[] {
  return moduleItems?.map((moduleItem) => moduleItem.id);
}

export function getModuleItemIconBySubType(moduleItemsConfig: ModuleItemsConfig, moduleItemSubType: string): string {
  let subTypeIcon = '';
  moduleItemsConfig?.itemTypes?.forEach((itemType) => {
    itemType?.subTypes.forEach((subType) => {
      if (subType?.type === moduleItemSubType) {
        subTypeIcon = subType.icon;
        return;
      }
    });
  });
  return subTypeIcon;
}

export function getModuleItemSubTypeLabel(
  moduleItemsConfig: ModuleItemsConfig,
  moduleItemType: string,
  moduleItemSubType: string
): string {
  let subTypeLabel = '';
  moduleItemsConfig?.itemTypes?.forEach((itemType) => {
    if (itemType?.type === moduleItemType) {
      itemType?.subTypes.forEach((subType) => {
        if (subType?.type === moduleItemSubType) {
          subTypeLabel = subType.label;
          return;
        }
      });
    }
  });
  return subTypeLabel;
}

export function prepareApiVideoUrl(videoUrl: string): string {
  const patternVimeo = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
  const patternYoutube = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

  let videoApiUrl = '';

  if (patternVimeo.test(videoUrl)) {
    videoApiUrl = videoUrl.includes('player.vimeo.com/video')
      ? videoUrl.replace('https:', '')
      : videoUrl.replace(patternVimeo, '//player.vimeo.com/video/$1');
  }

  if (patternYoutube.test(videoUrl)) {
    videoApiUrl = videoUrl.includes('embed')
      ? videoUrl.replace('https:', '')
      : videoUrl.replace(patternYoutube, '//www.youtube.com/embed/$1');
  }

  return videoApiUrl;
}

export function areThereValidMinMaxMessage(minValue: number, maxValue: number): string {
  return !isNaN(minValue) && !isNaN(maxValue) && minValue > maxValue ? "Minimum can't be greater than maximum" : '';
}

export function areThereValidNameForCalculationMessage(forCalculation: boolean, calculationName: string): string {
  return forCalculation && !calculationName ? 'Please check numeric calculation settings' : '';
}

export function getNumberChoices(minValue: number, maxValue: number, stepSize: number): number[] {
  const choices = [];
  let numberOfChoices = 0;
  if (stepSize > 0) {
    for (let i = minValue; i <= maxValue; i = i + stepSize, numberOfChoices++) {
      choices.push(i);
      if (numberOfChoices > 10) {
        break;
      }
    }
  }
  return choices;
}

export function getStringChoices(moduleItem: ModuleItem, selectedLanguage): string[] {
  const choicesAttribute = moduleItem.attributes.find(
    (attribute) => attribute.attribute === MODULE_ITEM_CHOICES_IDENTIFIER
  );

  return choicesAttribute.translations
    .find((translation) => translation.translation && translation.language === selectedLanguage.code)
    .translation.split('\n')
    .filter((row) => row);
}
